"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDocumentItem = exports.mapToDocumentItemProps = exports.isDocumentPending = exports.getFilesInProgress = void 0;
var _DocumentItem = require("../DocumentItem");
var _jsxRuntime = require("react/jsx-runtime");
const mapToDocumentItemProps = (documentStoreData, canDelete, isShowApprovalState, deleteConfirmationRequired, removeDocument) => {
  const document = {
    approval: documentStoreData.approval,
    documentId: documentStoreData.documentId,
    fileName: documentStoreData.fileName ?? '',
    fileSize: documentStoreData.fileSize
  };
  return {
    document,
    canDelete,
    isShowApprovalState,
    onDocumentRemove: removeDocument,
    isDeleteConfirmationRequired: deleteConfirmationRequired || false
  };
};
exports.mapToDocumentItemProps = mapToDocumentItemProps;
const getFilesInProgress = (filesInProgress, removeFile) => {
  const filesItems = filesInProgress.map(document => ({
    ...document,
    onDocumentRemove: removeFile
  }));
  return filesItems;
};
exports.getFilesInProgress = getFilesInProgress;
const isDocumentPending = document => !document.approval || document.approval.approvalState === 'Pending';
exports.isDocumentPending = isDocumentPending;
const renderDocumentItem = (documentProps, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItem.DocumentItem, {
  ...documentProps
}, key);
exports.renderDocumentItem = renderDocumentItem;